import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineClockTwoIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 2a10 10 0 1 0 0 20.0001A10 10 0 0 0 12 2Zm0 18a8.0005 8.0005 0 0 1-7.391-4.9385A8 8 0 1 1 12 20Zm2.1-10.37-1.1.64V7a1.0002 1.0002 0 0 0-1.7071-.7071A1.0002 1.0002 0 0 0 11 7v5.06a1.4202 1.4202 0 0 0 0 .2c.0155.0614.0355.1216.06.18v.06c.0478.0709.1013.1378.16.2a.9204.9204 0 0 0 .28.19h.08c.1303.067.2736.1045.42.11a.9984.9984 0 0 0 .34-.07h.16l2.6-1.5a1.0033 1.0033 0 1 0-1-1.74v-.06Z"/>
  </SvgIcon>
}

export default LineClockTwoIcon
